import {Component, Input, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {ModalDialogDismissOption} from '@shared/confirmation-dialog/modal-dialog-dismiss-option';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Machine} from '@models/machine/machine';

@Component({
    selector: 'scitis-clone-user-defined-page',
    templateUrl: './clone-user-defined-page.component.html',
    styleUrls: ['./clone-user-defined-page.component.scss'],
    standalone: false
})
export class CloneUserDefinedPageComponent implements OnInit {

  @Input()
  public pageName: string = '';

  @Input()
  public organizationId: string = '';

  @Input()
  public isAdminOrHigher: boolean = false;

  public modalTitle: string = '';
  public setAsShared: boolean = false;
  public machines: Machine[] = [];
  public selectedMachineIds: number[] = [];

  constructor(
      private translate: TranslateService,
      private activeModal: NgbActiveModal) {
  }

  ngOnInit() {
    this.setTranslations();
  }

  onClose(): void {
    this.activeModal.dismiss(ModalDialogDismissOption.CLOSE);
  }

  onCancel(): void {
    this.activeModal.dismiss(ModalDialogDismissOption.CANCEL);
  }

  onCopyPage(): void {
    const selectedMachineIds: number[] = [];
    if (!this.selectedMachineIds || this.selectedMachineIds.length === 0) {
      this.activeModal.close(selectedMachineIds);
    }
    this.selectedMachineIds.forEach(m => {
      if (m && m > 0) {
        selectedMachineIds.push(m);
      }
    });
    this.activeModal.close({targetMachineIds: selectedMachineIds, sharedPage: this.setAsShared});
  }

  onSetAsSharedChanged(): void {
    this.setAsShared = !this.setAsShared;
  }

  public onUpdateSelectedMachines(selectedMachineIds: number[]) {
    this.selectedMachineIds = selectedMachineIds;
  }

  private setTranslations(): void {
    this.modalTitle = this.translate.instant('Copying user defined page') + ' ' + this.pageName.toBold();
  }

}
